import { useCallback, useState } from 'react';

// Risk / remediation rows are tall expandable cards, so the useful range sits lower than a
// typical table. 10 is the default; 5 for a quick scan, 25/50 for bulk triage.
export const PAGE_SIZE_OPTIONS = [5, 10, 25, 50];
export const DEFAULT_PAGE_SIZE = 10;

const storageKey = (listKey) => `axaris_page_size_${listKey}`;

/**
 * Page size for a client-paginated list, remembered per list in localStorage.
 *
 * @param {string} listKey stable id for the list (e.g. 'risks', 'remediations', 'riskRegister')
 * @returns {[number, (size: number) => void]}
 */
export function usePageSize(listKey) {
    const [pageSize, setPageSizeState] = useState(() => {
        const stored = parseInt(localStorage.getItem(storageKey(listKey)), 10);
        return PAGE_SIZE_OPTIONS.includes(stored) ? stored : DEFAULT_PAGE_SIZE;
    });

    const setPageSize = useCallback((size) => {
        const next = PAGE_SIZE_OPTIONS.includes(size) ? size : DEFAULT_PAGE_SIZE;
        localStorage.setItem(storageKey(listKey), String(next));
        setPageSizeState(next);
    }, [listKey]);

    return [pageSize, setPageSize];
}
